// extracted by mini-css-extract-plugin
export default {"error":"error_error__e-9Fy","title":"error_title__bVWd8","desc":"error_desc__Av2vj"};